import React, { useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import useGoogleAnalytics from '~/single-page/hooks/useGoogleAnalytics';

export default function TestAnalytics() {
  const { trackEvent, isGAReady } = useGoogleAnalytics();

  useEffect(() => {
    console.log('Debug: Componente TestAnalytics montado');
    console.log('Debug: window.gtag disponível?', !!window.gtag);
    console.log('Debug: GA ID configurado?', !!window.gaTrackingId);
  }, []);

  const handleTestClick = () => {
    console.log('Debug: Botão clicado');
    console.log('Debug: Estado atual do gtag:', {
      gtagConfigured: !!window.gtag,
      gaConfigured: !!window.gaTrackingId,
      dataLayerExists: !!window.dataLayer,
      isGAReady
    });

    trackEvent(
      'test_click',           // ação
      'test_category',        // categoria
      'botao_teste',         // rótulo
      1                      // valor
    );
    alert('Evento enviado! Verifique o console do navegador.');
  };

  const handleTestNavigation = () => {
    console.log('Debug: Testando navegação');
    window.location.href = '/';
  };

  return (
    <Stack spacing={2} alignItems="center" sx={{ mt: 4 }}>
      <Typography variant="h6">
        Teste do Google Analytics
      </Typography>

      <Typography variant="body2" color="text.secondary">
        Status do GA: {isGAReady ? 'Pronto' : 'Carregando...'}
      </Typography>

      <Button 
        variant="contained" 
        color="primary"
        onClick={handleTestClick}
        disabled={!isGAReady}
      >
        Testar Evento
      </Button>

      <Button 
        variant="outlined" 
        color="secondary"
        onClick={handleTestNavigation}
      >
        Testar Navegação
      </Button>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Abra o console do navegador (F12) para ver os eventos sendo enviados
      </Typography>

      {!isGAReady && (
        <>
          <Typography variant="body2" color="error">
            O Google Analytics ainda não está pronto. Verifique se:
          </Typography>
          <ul>
            <li>O Google Analytics está configurado corretamente</li>
            <li>Não há bloqueadores de anúncios ativos</li>
            <li>A página foi completamente carregada</li>
          </ul>
        </>
      )}
    </Stack>
  );
} 